import { Component, ElementRef, OnInit, Inject, ViewChild,} from '@angular/core'
import { BlockNotasModel, ResponseBlockNotasModel } from 'src/app/model/BlockNotas.model';
import { apiService } from 'src/app/service/api.service';
import { AulaVirtualComponent } from '../../aula-virtual.component';


@Component({
  selector: 'app-notas',
  templateUrl: './notas.component.html',
  styleUrls: ['./notas.component.css']
})
export class NotasComponent implements OnInit {

  @ViewChild('divSpinner') divSpinner:ElementRef;
  cargando :boolean;
  notes = [];
  recognition:any;
  idJardinPeriodo : number;
  constructor(
    private el:ElementRef,@Inject(AulaVirtualComponent) private parent: AulaVirtualComponent,
    private apiService: apiService,) {
    //this.notes = JSON.parse(localStorage.getItem('notes')) || [{ id: 0,content:'' }];
    const {webkitSpeechRecognition} : IWindow = <IWindow><unknown>window;
    this.recognition = new webkitSpeechRecognition();
    this.recognition.onresult = (event)=> {
      this.el.nativeElement.querySelectorAll(".content")[0].innerText = event.results[0][0].transcript
      
    };
    
  }

  ngOnInit(): void {
    this.cargando=true;
    this.cargarBlockNotas();
    this.idJardinPeriodo = this.apiService.dataJardin.idJardinPeriodo;
  }

  

  cargarBlockNotas(){
    this.apiService.API_POST_getMisBlockNotas().subscribe((response: ResponseBlockNotasModel) => {
      this.notes = response.payload;
      this.cargando = false;
      this.divSpinner.nativeElement.style.display='none';
    },
    (err) => {
      console.log(err)
      this.cargando = false;
    })
  }
  
  updateAllNotes() {

    let notes = document.querySelectorAll('app-note');

    notes.forEach((note, index)=>{

         this.notes[note.id].contenido = note.querySelector('.content').innerHTML;
    });

    localStorage.setItem('notes', JSON.stringify(this.notes));

  }

  addNote () {
    this.divSpinner.nativeElement.style.display='';
    var nota = new BlockNotasModel();
    nota.idJardinPeriodo = this.idJardinPeriodo;
    nota.contenido = "";
    this.apiService.API_POST_crearBlockNota(nota).subscribe((response: any) => {
      this.notes.push(response.payload);
      this.divSpinner.nativeElement.style.display='none';
    },
    (err) => {
      console.log(err);
      this.divSpinner.nativeElement.style.display='none';
    })
    //this.notes.push({ id: this.notes.length + 1,content:'' });
    // sort the array
    //this.notes= this.notes.sort((a,b)=>{ return b.id-a.id});
    //localStorage.setItem('notes', JSON.stringify(this.notes));
  };
  
  saveNote(event){
    const id = event.srcElement.parentElement.parentElement.getAttribute('id');
    const content = event.target.innerText;
    event.target.innerText = content;
    const json = {
      'id':id,
      'content':content
    }
    this.updateNote(json);
  }
  
  updateNote(newValue){
    this.divSpinner.nativeElement.style.display='';
    this.notes.forEach((note, index)=>{
      if(note.idBlockNotas== newValue.id) {
        this.notes[index].contenido = newValue.content;
        this.apiService.API_POST_actualizarBlockNota(this.notes[index]).subscribe((response: any) => {
          this.divSpinner.nativeElement.style.display='none';
        },(err) => {
          console.log(err);
          this.divSpinner.nativeElement.style.display='none';
        })
      }
    });
  }
  

  deleteNote(event){
      this.divSpinner.nativeElement.style.display='';
      const id = event.srcElement.parentElement.parentElement.parentElement.getAttribute('id');
      var nota = new BlockNotasModel();
      nota.idBlockNotas = id;
      this.apiService.API_POST_deleteBlockNota(nota).subscribe((response: any) => {
        this.divSpinner.nativeElement.style.display='none';
      },
      (err) => {
        console.log(err);
        this.divSpinner.nativeElement.style.display='none';
      })

     this.notes.forEach((note, index)=>{
      if(note.idBlockNotas== id) {
        this.notes.splice(index,1);
        return;
      }
    });
  }

   record(event) {
    this.recognition.start();
    this.addNote();
  }


  volver(){
    this.parent.ngOnInit();
    this.parent.showAgenda = false;
  }


}


export interface IWindow extends Window {
  webkitSpeechRecognition: any;
}